__turbopack_context__.v({
  "arrow": "swipeable-cards-list-module__7FqGXW__arrow",
  "onlyOnSmallScreen": "swipeable-cards-list-module__7FqGXW__onlyOnSmallScreen",
  "page": "swipeable-cards-list-module__7FqGXW__page",
  "scroll": "swipeable-cards-list-module__7FqGXW__scroll",
  "selected": "swipeable-cards-list-module__7FqGXW__selected",
  "swipeableCardsList": "swipeable-cards-list-module__7FqGXW__swipeableCardsList",
});
